import { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
// React Router
import { useHistory } from 'react-router-dom';

// Components
import { Icon } from '@components';

// Services
import { Api, favoriteService } from '@services';

// Utils
import { isAdmin, isSuperAdmin, isSystemAdmin } from '@utils';

// Store
import { useMapStore } from '../../MapStore/UseMapStore';

// React App Hook
import { useApp } from '@react';

export function MapInfoTitle({ mapType, mapTitle }) {
  const [isFavorite, setIsFavorite] = useState<boolean>(false);
  const mapID = useMapStore((state) => state.mapID);
  const resetAllSlices = useMapStore((state) => state.resetAllSlices);
  const history = useHistory();
  const app = useApp();
  const authorized = (isAdmin() || isSystemAdmin() || isSuperAdmin()) && mapType !== 'Legacy';

  useEffect(() => {
    checkIsFavorite(app, mapID);
  }, []);

  const checkIsFavorite = async (app, id) => {
    const { data } = await favoriteService.getFavorites(app.id);
    const isFavorite = data.find((fav) => fav.itemType === 'Map' && fav.itemId.toString() === id);
    isFavorite ? setIsFavorite(true) : setIsFavorite(false);
  };

  const favoriteMap = async () => {
    setIsFavorite(true);
    return Api.post(`/maps/${mapID}/favorites`);
  };

  const unfavoriteMap = async () => {
    setIsFavorite(false);
    return Api.delete(`/maps/${mapID}/favorites`);
  };

  return (
    <div className="title-bar">
      <Card.Header>
        <div className="d-flex flex-row justify-content-between align-items-center">
          <div className="d-flex flex-row justify-content-start align-items-center">
            <Icon
              name={isFavorite ? 'star-fill' : 'star-empty'}
              variant="light"
              size="md"
              className="align-sub primary-icon map-favorite"
              disabled={false}
              showPointer={true}
              onClick={isFavorite ? unfavoriteMap : favoriteMap}
            />
            <h4 className="mb-0 ms-1">{mapTitle}</h4>
          </div>
          <div className="d-flex flex-row justify-content-end align-items-center">
            {authorized && (
              <Icon
                name={'edit'}
                className="align-sub primary-icon map-edit"
                variant="light"
                disabled={false}
                size="md"
                showPointer={true}
                onClick={() => {
                  resetAllSlices();
                  history.push(mapID + '/edit');
                }}
              />
            )}
          </div>
        </div>
      </Card.Header>
    </div>
  );
}
